// extracted by mini-css-extract-plugin
module.exports = {"loading-main-button":"loading-spinner_loading-main-button__Zy9lX","a":"loading-spinner_a__zrQIj","loading-button-overlay":"loading-spinner_loading-button-overlay__tkyng"};